<template>
  <el-container class="container">
    <el-header class="header">
      <el-row>
        <el-col :span="2">
          <img @click="goToHome()"
               src="~assets/img/logo.png"
               alt="图片无法显示"
               style="height: 42px; cursor: pointer" />
        </el-col>
        <el-col :span="18">
          <div class>当前目的地</div>
        </el-col>
        <!-- 个人中心 -->
        <el-col :span="4">
          <div style="display: flex; height: 40px; margin-top: 10px">
            <a class="J_AppLink"
               href="/account/settings">
              <img src="http://img4.imgtn.bdimg.com/it/u=3701847413,2165986719&fm=11&gp=0.jpg"
                   style="
                  height: 40px;
                  width: 40px;
                  border-radius: 40px;
                  margin-right: 8px;
                " />
            </a>
            <div>
              <p style="
                  height: 20px;
                  line-height: 20px;
                  color: rgb(51, 51, 51);
                  display: flex;
                  align-items: center;
                ">
                <span title="星球玩家俱乐部"
                      style="
                    display: inline-block;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    max-width: 150px;
                  ">{{userName}}</span>
              </p>

              <p @click="handleLogout()"
                 style="
                  height: 20px;
                  line-height: 20px;
                  font-size: 12px;
                  color: rgb(153, 153, 153);
                  cursor: pointer;
                ">
                旅行规划师 | 退出
                <i class="next-icon next-icon-arrow-down-filling next-icon-xxs"
                   style="margin-left: 3px; color: rgb(83, 102, 123)"></i>
              </p>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-header>
    <div class="main-background"
         style="width: 100%; background-color: rgb(241, 236, 235)">
      <div class="main">
        <!-- 菜单栏 -->
        <!-- 开启路由模式，和唯一打开菜单 绑定一下就变布尔值了 -->
        <div class="aside">
          <el-menu active-text-color="#FF5421"
                   :default-active="defaultActive"
                   :router="true"
                   :unique-opened="true"
                   style="height: 100%; width: 180px; border-radius: 3px">
            <!-- 菜单0：总揽 -->
            <el-submenu index="/trip-data">
              <template slot="title">
                <!-- 导航的图标 -->
                <i class="el-icon-monitor"></i>
                <!-- 导航文字 -->
                <span>首页</span>
              </template>
              <!-- 子菜单 -->
              <el-menu-item index="/booking_data">
                <i class="el-icon-s-data"></i>
                <span>订单数据</span>
              </el-menu-item>
              <el-menu-item index="/traver_data">
                <i class="el-icon-s-order"></i>
                <span>规划数据</span>
              </el-menu-item>
              <el-menu-item index="/user_data">
                <i class="el-icon-user-solid"></i>
                <span>用户管理</span>
              </el-menu-item>
            </el-submenu>
            <!-- 菜单1：行程库 -->
            <el-submenu index="1">
              <template slot="title">
                <!-- 导航的图标 -->
                <i class="el-icon-takeaway-box"></i>
                <!-- 导航文字 -->
                <span>帮你做攻略</span>
              </template>
              <!-- 子菜单 -->
              <el-menu-item index="requirement_list">
                <i class="el-icon-star-off"></i>
                <span>需求中心</span>
              </el-menu-item>
              <el-menu-item @click="menuToReservationForm">
                <i class="el-icon-notebook-2"></i>
                <span>预定清单</span>
              </el-menu-item>
            </el-submenu>
            <!-- 菜单2：素材中心 -->
            <el-submenu index="2">
              <template slot="title">
                <i class="el-icon-s-opportunity"></i>
                <span>创作中心</span>
              </template>
              <el-menu-item index="travel_plan_list">
                <i class="el-icon-files"></i>
                <span>方案库</span>
              </el-menu-item>
              <el-menu-item index="day_trip_list">
                <i class="el-icon-s-flag"></i>
                <span>日行程库</span>
              </el-menu-item>
              <el-menu-item index="traver_point_list">
                <i class="el-icon-location"></i>
                <span>迹点库</span>
              </el-menu-item>
              <el-menu-item index="content_list">
                <i class="el-icon-receiving"></i>
                <span>内容库</span>
              </el-menu-item>
              <el-menu-item index="residence_hub_list">
                <i class="el-icon-school"></i>
                <span>酒店/民宿库</span>
              </el-menu-item>
              <el-menu-item index="check_list">
                <i class="el-icon-circle-check"></i>
                <span>出行核对清单</span>
              </el-menu-item>
              <el-menu-item index="before_trip_list">
                <i class="el-icon-s-management"></i>
                <span>行前手册</span>
              </el-menu-item>
            </el-submenu>

            <!-- 菜单3：订单管理 -->
            <el-submenu index="5">
              <template slot="title">
                <i class="el-icon-date"></i>
                <span>预定管理</span>
              </template>
              <!-- 子菜单 -->
              <el-menu-item index="/product_list">
                <i class="el-icon-files"></i>
                <span>产品库</span>
                <!-- 添加产品，管理产品 -->
              </el-menu-item>
              <el-menu-item index="/booking_list">
                <i class="el-icon-files"></i>
                <span>订单管理</span>
              </el-menu-item>
              <el-menu-item index="/booking_bill">
                <i class="el-icon-notebook-2"></i>
                <span>对账中心</span>
              </el-menu-item>
            </el-submenu>
            <!-- 菜单4：个人中心 -->
            <el-menu-item index="/profile">
              <i class="el-icon-s-custom"></i>
              <span slot="title">个人中心</span>
            </el-menu-item>
            <!-- 菜单5：全局配置 -->
            <el-submenu index="4">
              <template slot="title">
                <i class="el-icon-s-tools"></i>
                <span>全局配置</span>
              </template>
              <!-- 子菜单 -->
              <el-menu-item index="/configpage">
                <i class="el-icon-notebook-2"></i>
                <span>基本配置</span>
              </el-menu-item>
              <el-menu-item index="/traver_guide_config">
                <i class="el-icon-files"></i>
                <span>行程规划配置</span>
              </el-menu-item>
              <el-menu-item index="/operator_list">
                <i class="el-icon-s-shop"></i>
                <span>服务商管理</span>
              </el-menu-item>
            </el-submenu>

            <!-- 菜单4：组件中心 -->
            <el-submenu index="/6">
              <template slot="title">
                <i class="el-icon-date"></i>
                <span>证书中心</span>
              </template>
              <!-- 子菜单 -->
              <el-menu-item index="/certificate">
                <i class="el-icon-notebook-2"></i>
                <span>冲浪证书</span>
              </el-menu-item>

              <el-menu-item index="/course">
                <i class="el-icon-files"></i>
                <span>课程中心</span>
                <!-- 添加产品，管理产品 -->
              </el-menu-item>
            </el-submenu>
            <!-- 菜单5：速至所想 -->
            <el-menu-item index="/szsx_configpage">
              <i class="el-icon-info"></i>
              <span slot="title">速至所想</span>
            </el-menu-item>
            <!-- 菜单6:其他网页条款生成 -->
            <el-menu-item index="/szsx_configpage">
              <i class="el-icon-info"></i>
              <span slot="title">条款库</span>
            </el-menu-item>
          </el-menu>
        </div>

        <!-- 菜单结束 -->
        <div class="aside-bottom"></div>

        <!-- 内容区 -->
        <div class="contain">
          <router-view></router-view>
        </div>
      </div>

      <el-footer class="footer">
        <!-- 备案信息 -->
        <copy-right :isFixed="true"></copy-right>
      </el-footer>
    </div>
  </el-container>
</template>

<script>
import CopyRight from '../../components/common/CopyRight'

import { mapState, mapMutations } from 'vuex'
export default {
  name: 'Home',
  components: {
    'copy-right': CopyRight,
  },
  data() {
    return {
      defaultActive: 'booking_data',
      userName: '',
    }
  },
  // 检查是否登陆
  created() {
    // this.checkLogin();
  },
  mounted() {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'))
    console.log()
    this.userName = userInfo.userName
  },
  methods: {
    ...mapMutations(['login', 'logout']),
    menuToReservationForm() {
      console.log('跳转')
      let newpage = this.$router.resolve({
        name: 'reservation_form',
      })
      window.open(newpage.href, '_blank')
    },
    goToHome() {
      this.$router.push({ path: '/booking_data' })
    },
    // 检查是否登陆 session 方式，改为token
    // checkLogin() {
    //   this.$http.get("/check_login").then((res) => {
    //     const { data, errno, errmsg } = res.data;
    //     if (errno == "4101") {
    //       this.$router.push({ path: "/login" });
    //     }
    //   });
    // },
    // 退出登陆 改为删除token
    handleLogout() {
      // 修改为公共mixin方法，全局调用
      this.logout()
      this.$router.push({ path: '/login' })
      // this.$http.delete("/session").then((res) => {
      //   this.$router.push({ path: "/login" });
      // });
    },
    // 进入注册页面
    handleLogin() {
      this.$router.push({ path: '/register' })
    },
  },
}
</script>

<style>
html body {
  height: 100%;
  background-color: rgb(241, 236, 235);
}

.container {
  height: 100%;
}

.header {
  height: 80px;
  background-color: white;
  border-top: 4px solid #ff5421;
  box-shadow: 3px 0 3px rgba(0, 0, 0, 0.3);
}

.account {
  line-height: 40px;
}

.main {
  display: flex;
  padding: 0 5px;
  margin: 15px auto;
  align-content: center;
  justify-content: center;
}
.main-background {
  width: 100%;
  height: 100%;
  background-color: rgb(241, 236, 235);
}
.el-menu .el-submenu .el-menu-item {
  min-width: 180px;
}

.aside {
  display: block;
  height: auto;
  background-color: rgba(0, 0, 0, 0);
  margin-right: 15px;
  border: 0px;
  border-radius: 3px 0px;
  flex: 0 0;
}

.contain {
  display: block;
  width: 1036px;
  /* width: 100%; */
  flex: initial;
}

.nickname {
  display: inline-block;
  overflow: hidden;
  margin-left: 20px;
  font-size: medium;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 150px;
}

.logout {
  display: block;
}
.footer {
  background-color: #ff5421;
  /* position: relative;
  bottom: 0; */
  width: 100%;
}
</style>